<template>
  <div>
    <div class="rew19_blue_back">
      <div class="rew19_header_title">
        <h2>스마트 뷰티 4+1 정기구매 소개</h2>
        <p>스마트 뷰티 전용 제품에 최적화된 4+1 정기구매 프로그램으로 가격적인 혜택은 물론 연속 구매에 따른 특별한 사은품을 만나보세요.<br><br>
          ※ 해당 프로그램은 2월 29일 결제 완료한 건까지 적용됩니다. (3월 1일부터 구매하신 분들께는 4+1 프로그램 사은품이 증정되지 않습니다.)</p>
      </div>
    </div>
    <div class="rew19-contents-tab">
      <a href="javascript:;" class="prev"></a>
      <div style="overflow-x:scroll;">
        <ul style="width: 700px;">
          <li :class="{active:activeCount == 1}"><router-link :to="{name:'fourplusIntroduce01'}">루미스파</router-link></li>
          <li :class="{active:activeCount == 3}"><router-link :to="{name:'fourplusIntroduce03'}">페이스 &amp; 바디 갈바닉</router-link></li>
<!--          <li :class="{active:activeCount == 5}"><router-link :to="{name:'fourplusIntroduce05'}">파워마스크</router-link></li>-->
          <li :class="{active:activeCount == 4}"><router-link :to="{name:'fourplusIntroduce04'}">루미스파 액센트</router-link></li>
          <li :class="{active:activeCount == 2}"><router-link :to="{name:'fourplusIntroduce02'}">에이지락 미</router-link></li>
        </ul>
      </div>
      <a href="javascript:;" class="next"></a>
    </div>
  </div>
</template>
<script>
export default {
  name: 'FourplusIntroduceHeader',
  components: {  },
  props: {
    activeCount : {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
    }
  },
  mounted() {
    let _this = this;

    _this.uiInit();
  },
  methods :{
    uiInit(){
      if($('.rew19-contents-tab li').is('.active')){
        var title = $('.rew19-contents-tab li.active a').text();
        document.title = title;
      }

      if($('.rew19-contents-tab ul li').is('.active')) {
          $('.rew19-contents-tab div').scrollLeft(($('.active').position().left) - 50)
      }else{
          $('.prev').hide();
      }

      $('.prev').on('click', function(){
          $('.rew19-contents-tab div').animate({
              'scrollLeft' : '-=300px'
          }, 'slow')
      });

      $('.next').on('click', function(){
          $('.rew19-contents-tab div').animate({
              'scrollLeft' : '+=300px'
          }, 'slow')
      });

      $('.rew19-contents-tab div').scroll(function(){
          if($(this).scrollLeft() < 50){
              $('.prev').hide();
          }else{
              $('.prev').show();
          }

          var width = $('.rew19-contents-tab div ul').width();

          if($(this).scrollLeft() > width-350){
              $('.next').hide();
          }else{
              $('.next').show();
          }
      });
    }
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/info/fourplusIntroduceHeader.vue